import React from "react";
import Index from "../views/dashboard/index";

//Admin
import AdminList from "../views/dashboard/admin/admin-list";
import AdminAdd from "../views/dashboard/admin/admin-add";
import AdminProfile from "../views/dashboard/admin/admin-profile";

//admin
import Admin from "../views/dashboard/admin/admin";
import Default from "../layouts/dashboard/default";

// Etsy
import CreateEtsyAccount from "../views/dashboard/etsy-accounts/create-etsy-account";
import EtsyAccountList from "../views/dashboard/etsy-accounts/etsy-account-list";
import EtsyAccountView from "../views/dashboard/etsy-accounts/view-etsy-account";
import EtsySuccess from "../views/dashboard/etsy-accounts/etsy-success";

//inquiry
import InquiryList from "../views/dashboard/inquiry/inquiry-list";
import InquiryView from "../views/dashboard/inquiry/inquiry-profile";

import RtlSupport from "../views/dashboard/special-pages/RtlSupport";
import Settings from "../views/dashboard/setting/setting";
import DiamondRates from "../views/dashboard/diamond/diamondRates";
import GoldRates from "../views/dashboard/gold-rates/GoldRates";

// Listing
import ListingList from "../views/dashboard/listing/listing";
import ViewListingProduct from "../views/dashboard/listing/view-listing-product";
import ProductList from "../views/dashboard/listing/product-list";
import Logs from "../views/dashboard/logs/logs";

export const DefaultRouter = [
  {
    path: "/",
    element: <Default />,
    children: [
      {
        path: "dashboard",
        element: <Index />,
      },
      {
        path: "dashboard/special-pages/rtl-support",
        element: <RtlSupport />,
      },
      {
        path: "dashboard/admin-list",
        element: <AdminList />,
      },
      {
        path: "dashboard/admin-add",
        element: <AdminAdd />,
      },
      {
        path: "dashboard/admin-profile",
        element: <AdminProfile />,
      },
      {
        path: "dashboard/admin",
        element: <Admin />,
      },
      {
        path: "dashboard/inquiry-list",
        element: <InquiryList />,
      },
      {
        path: "dashboard/inquiry-view",
        element: <InquiryView />,
      },
      {
        path: "etsy/list",
        element: <EtsyAccountList />,
      },
      {
        path: "etsy/list",
        element: <EtsyAccountList />,
      },
      {
        path: "etsy/success",
        element: <EtsySuccess />,
      },
      {
        path: "etsy/create",
        element: <CreateEtsyAccount />,
      },
      {
        path: "etsy/view",
        element: <EtsyAccountView />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "diamond-rates",
        element: <DiamondRates />,
      },
      {
        path: "gold-rates",
        element: <GoldRates />,
      },
      {
        path: "listing/list",
        element: <ListingList />,
      },
      {
        path: "listing/view-product",
        element: <ViewListingProduct />,
      },
      {
        path: "product/list",
        element: <ProductList />,
      },
      {
        path: "logs",
        element: <Logs />,
      },
    ],
  },
];
